import React, { useState, useRef } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartWithLegendTooltip = ({ chartData }) => {
    const [legendTooltip, setLegendTooltip] = useState({ show: false, x: 0, y: 0, description: '', value: 0 });
    const containerRef = useRef(null);

    // Extract labels, values, and descriptions
    const labels = chartData.map(item => item.name);
    const values = chartData.map(item => parseFloat(item.value.toString().replace('%', '').replace(',', '').replace('$', '')) || 0);
    const descriptions = chartData.map(item => item.description || ''); // new field

    const backgroundColors = [
        '#4e79a7', '#f28e2c', '#e15759', '#76b7b2', '#59a14f', '#edc949',
        '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab'
    ];

    const data = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: backgroundColors.slice(0, values.length),
            borderWidth: 1,
        }]
    };

    const options = {
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const val = context.parsed;
                        return `${val.toFixed(2)}%`;
                    }
                }
            }
        }
    };

    return (
        <div
            ref={containerRef}
            style={{ position: 'relative', width: '300px', height: '300px', margin: '0 auto' }}
        >
            {/* Custom legend */}
            <div className="custom-legend" style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '1rem',
                gap: '1.5rem',
                flexWrap: 'wrap'
            }}>
                {labels.map((label, index) => (
                    <div
                        key={index}
                        onMouseEnter={(e) => {
                            const rect = containerRef.current.getBoundingClientRect();
                            setLegendTooltip({
                                show: true,
                                description: descriptions[index], // show description here
                                value: values[index],
                                x: e.clientX - rect.left + 10,
                                y: e.clientY - rect.top + 10
                            });
                        }}
                        onMouseMove={(e) => {
                            const rect = containerRef.current.getBoundingClientRect();
                            setLegendTooltip(prev => ({
                                ...prev,
                                x: e.clientX - rect.left + 10,
                                y: e.clientY - rect.top + 10
                            }));
                        }}
                        onMouseLeave={() => setLegendTooltip({ show: false })}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 500
                        }}
                    >
                        <div style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: backgroundColors[index],
                            marginRight: '8px',
                        }}></div>
                        {label}
                    </div>
                ))}
            </div>

            <Pie data={data} options={options} />

            {/* Tooltip */}
            {legendTooltip.show && (
                <div style={{
                    position: 'absolute',
                    top: legendTooltip.y,
                    left: legendTooltip.x,
                    background: 'rgba(0, 0, 0, 0.85)',
                    color: '#fff',
                    padding: '6px 10px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    pointerEvents: 'none',
                    zIndex: 9999,
                    whiteSpace: 'normal',
                    minWidth: '200px',
                    maxWidth: '400px'
                }}>
                    {legendTooltip.description}: {legendTooltip.value.toLocaleString() + "%"}
                </div>
            )}
        </div>
    );
};

export default PieChartWithLegendTooltip;